import { render, staticRenderFns } from "./MyOrders.vue?vue&type=template&id=4e31ac03&scoped=true&lang=html"
import script from "./MyOrders.vue?vue&type=script&lang=js"
export * from "./MyOrders.vue?vue&type=script&lang=js"
import style0 from "./MyOrders.vue?vue&type=style&index=0&id=4e31ac03&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e31ac03",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/www/html/untrrv2/frontend-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4e31ac03')) {
      api.createRecord('4e31ac03', component.options)
    } else {
      api.reload('4e31ac03', component.options)
    }
    module.hot.accept("./MyOrders.vue?vue&type=template&id=4e31ac03&scoped=true&lang=html", function () {
      api.rerender('4e31ac03', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/account/MyOrders.vue"
export default component.exports